import { render, staticRenderFns } from "./PropertyItem.vue?vue&type=template&id=22a9fd8b&"
import script from "./PropertyItem.vue?vue&type=script&lang=js&"
export * from "./PropertyItem.vue?vue&type=script&lang=js&"
import style0 from "./PropertyItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports